const r2 = (x) => Math.round((x + Number.EPSILON) * 100) / 100;

export function importRollup(det = {}) {
  det = det || {};
  const amt = (k) => Number((det[k] || {}).amount || 0);
  const tra = det.tra_assessment || {};
  const traVat = Number(tra.vat || 0);
  const components = {
    Freight: amt("freight_invoice"),
    "Import Duty": Number(tra.import_duty || 0),
    RDL: Number(tra.rdl || 0),
    CPF: Number(tra.cpf || 0),
    "TRA Others": Number(tra.others || 0),
    "TRA VAT": traVat,
    Swissport: amt("swissport"),
    "Shipping Line": amt("shipping_line"),
    Wharfage: amt("wharfage"),
    GCLA: ((det.gcla || {}).lines || [det.gcla || {}]).reduce((s, l) => s + Number(l.amount || 0) * ((l.currency || "TZS") === "TZS" ? 1 : (Number(l.fx_rate) || 1)), 0),
    TBS: amt("tbs"),
    "Agent Fee": amt("agent_fee"),
    Transport: amt("transport"),
    "Other Charges": (det.other_charges || []).reduce((s, o) => s + Number(o.amount || 0) * ((o.currency || "TZS") === "TZS" ? 1 : (Number(o.fx_rate) || 1)), 0),
  };
  const total = Object.values(components).reduce((s, v) => s + v, 0);
  return { components, total: r2(total), landed_total: r2(total - traVat) };
}

export function importChecklist(det = {}) {
  det = det || {};
  const g = (k) => det[k] || {};
  const tra = g("tra_assessment");
  // Documents that can be flagged "Not Applicable" (excluded from the pending count when off).
  const toggleable = ["sadc", "coc", "tbs", "gcla", "transport"];
  const isApplicable = (k) => g(k).applicable !== false; // default: applicable
  const has = {
    freight_invoice: !!(g("freight_invoice").amount || g("freight_invoice").tax_invoice_no || (g("freight_invoice").efd || {}).code),
    sadc: !!g("sadc").reference,
    coc: !!g("coc").reference,
    tra_assessment: !!(tra.import_duty || tra.rdl || tra.cpf || tra.vat || tra.assessment_ref || tra.payment_note_ref),
    tbs: !!g("tbs").reference,
    swissport: !!(g("swissport").reference || g("swissport").amount),
    bill_of_lading: !!g("bill_of_lading").reference,
    shipping_line: !!(g("shipping_line").reference || g("shipping_line").amount),
    wharfage: !!(g("wharfage").reference || g("wharfage").amount),
    gcla: !!(g("gcla").reference || g("gcla").amount),
    release_order: !!g("release_order").reference,
    agent_fee: !!(g("agent_fee").amount || g("agent_fee").tax_invoice_no),
    transport: !!g("transport").amount,
    other_charges: (det.other_charges || []).length > 0,
  };
  let total = 0;
  let captured = 0;
  for (const k of Object.keys(has)) {
    if (toggleable.includes(k) && !isApplicable(k)) continue; // Not Applicable → exclude
    total += 1;
    if (has[k]) captured += 1;
  }
  return { captured, total, pending: total - captured };
}
